import { PURGE } from 'redux-persist'
import { SET_OPEN_SUBSCRIPTION_MODAL, SET_USER_SUBSCRIPTION, SET_IS_ELIGIBLE_FOR_LEARNTUBE_MAX } from '../actions/types';

export default function (state = { open_subscription_modal: false,isEligibleForLearntubeMax : false , cache_time : 0}, action) {
    switch (action.type) {
        case PURGE:
            return null;
        case SET_USER_SUBSCRIPTION:
            return {
                ...state, ...action.payload
            }
        case SET_OPEN_SUBSCRIPTION_MODAL: {
            return {
                ...state, open_subscription_modal: action.payload
            }
        }
        case SET_IS_ELIGIBLE_FOR_LEARNTUBE_MAX :{
            return{
                ...state, isEligibleForLearntubeMax : action.payload
            }
        }
        default:
            return state;
    }
}